import FJTextStyle from './FJTextStyle';
import FJShadows from './style/FJShadows';

class FJTextStyleGlow extends FJTextStyle {
    initStyles(props = {}) {
        const glow = new FJShadows({
            ...props,
            shadowList: [
                {
                    ...props,
                    offset: 0,
                    angle: 0,
                    blur: 20,
                    color: '#23D895',
                    position: 'relative',
                },
                {
                    // 第一层 带阴影（视觉效果上）
                    ...props,
                    offset: 0,
                    angle: 0,
                    blur: 30,
                    color: '#23D895',
                    position: 'absolute',
                },
            ],
            position: 'relative',
        });
        this._styles = [glow];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{color: *, blur: *}}
     */
    getAdjustInfo() {
        const glow = this._styles[0];
        const info = glow.shadowList[0];
        return {
            blur: info.blur,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        if (info.blur !== '') {
            const glow = this._styles[0];
            const shadowList = glow.shadowList;
            shadowList[0].blur = info.blur;
            shadowList[1].blur = info.blur + 10;
            glow.shadowList = [...shadowList];
        }
    }

    /**
     * @description 设置color
     * @param color
     */
    setColor(color) {
        const glow = this._styles[0];
        const shadowList = glow.shadowList;
        shadowList.forEach(style => {
            style.color = color;
        });
        glow.shadowList = shadowList;
    }
}

export default FJTextStyleGlow;
